import http from './api'

const route = 'app/comercial/entregaleite/'

export default {
  showprodutoresPositivados: (dataInicial, dataFinal, empresa, produtor, tokenContrato, linhasSelect) => {
    return http.post(route + 'showprodutoresPositivados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresa: empresa,
      produtor: produtor,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showDelhamentoProdutoresPositivados: (dataInicial, dataFinal, empresa, produtor, tokenContrato, linhasSelect) => {
    return http.post(route + 'showDelhamentoProdutoresPositivados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresa: empresa,
      produtor: produtor,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showDelhamentoProdutoresAtivos: (dataInicial, dataFinal, empresa, produtor, tokenContrato, linhasSelect) => {
    return http.post(route + 'showDelhamentoProdutoresAtivos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresa: empresa,
      produtor: produtor,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showLocalizacaoProdutores: (dataInicial, dataFinal, empresa, produtores, tokenContrato, linhasSelect) => {
    return http.post(route + 'showLocalizacaoProdutores', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresa: empresa,
      produtor: produtores,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showEntregaLeiteNovosProdutores: (dataInicial, dataFinal, empresa, produtores, tokenContrato, linhasSelect) => {
    return http.post(route + 'showEntregaLeiteNovosProdutores', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresa: empresa,
      produtor: produtores,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showProdutoresNovos: (dataInicial, dataFinal, empresa, produtores, tokenContrato, linhasSelect) => {
    return http.post(route + 'showProdutoresNovos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresa: empresa,
      produtor: produtores,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showComparativoProdutores: (dataInicial, dataFinal, empresa, produtores, tokenContrato, linhasSelect) => {
    return http.post(route + 'showComparativoProdutores', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      empresa: empresa,
      produtor: produtores,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showMelhoresProdutores: (dataInicial, dataFim, empresa, produtores, tokenContrato, linhasSelect) => {
    return http.post(route + 'showMelhoresProdutores', {
      dataInicio: dataInicial,
      dataFim: dataFim,
      empresa: empresa,
      produtor: produtores,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showDelhamentoMelhoresEntregasProdutores: (dataInicial, dataFim, empresa, produtores, tokenContrato, linhasSelect) => {
    return http.post(route + 'showDelhamentoMelhoresEntregasProdutores', {
      dataInicio: dataInicial,
      dataFim: dataFim,
      empresa: empresa,
      produtor: produtores,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showMelhoresEntregasPorLinha: (dataInicial, dataFim, empresa, tokenContrato, produtorSelect, linhasSelect) => {
    return http.post(route + 'showMelhoresEntregasPorLinha', {
      dataInicio: dataInicial,
      dataFim: dataFim,
      empresa: empresa,
      tokenContrato: tokenContrato,
      produtor: produtorSelect,
      linhasleite: linhasSelect,
    })
  },
  showDelhamentoEntregasLinhaLeite: (dataInicial, dataFim, empresa, produtores, tokenContrato, linhasSelect) => {
    return http.post(route + 'showDelhamentoEntregasLinhaLeite', {
      dataInicio: dataInicial,
      dataFim: dataFim,
      empresa: empresa,
      produtor: produtores,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
  showFiltroPorLinhas: (tokenContrato, linha) => {
    return http.post(route + 'showFiltroPorLinhas', {
      tokenContrato: tokenContrato,
      linhasleite: linha,
    })
  },
  showComparativoVolumeLeite: (primeiroDia, ultimoDia, empresaSelect, tokenContrato, linhaSelect) => {
    return http.post(route + 'showComparativoVolumeLeite', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      empresa: empresaSelect,
      tokenContrato: tokenContrato,
      linhasleite: linhaSelect,
    })
  },
  showComparativoPrecoMedioLeite: (primeiroDia, ultimoDia, empresaSelect, tokenContrato, linhaSelect) => {
    return http.post(route + 'showComparativoPrecoMedioLeite', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      empresa: empresaSelect,
      tokenContrato: tokenContrato,
      linhasleite: linhaSelect,
    })
  },
  showLeiteColetado: (dataInicial, dataFim, empresa, produtores, tokenContrato, linhasSelect) => {
    return http.post(route + 'showLeiteColetado', {
      dataInicio: dataInicial,
      dataFim: dataFim,
      empresa: empresa,
      produtor: produtores,
      tokenContrato: tokenContrato,
      linhasleite: linhasSelect,
    })
  },
}
